import { Controller } from "@hotwired/stimulus";
import { fetchStream } from "../utils/turbo_utils";

export default class extends Controller {
  connect() {
    fetchStream(this.element.dataset.src);
  }
}
